import React from 'react';
import { Link } from 'react-router-dom';

/** 简体中文隐私政策 — 与 App Store App Privacy 披露对齐 */
export default function PrivacyZh() {
  return (
    <>
      <h1>隐私政策</h1>
      <p className="muted">生效日期：2026年5月27日 · 最后更新：2026年5月27日</p>
      <p className="lede">
        <strong>omw（在路上了）</strong>是一款基于位置的社交应用，帮助你在地图上发现活动、路线、宝藏与同城社区。本政策说明我们收集哪些个人信息、为何收集、与谁共享以及你有哪些选择。本政策旨在符合 Apple App Store 审核指南 5.1 及 App Store Connect 中的 App Privacy 填写要求。
      </p>

      <h2>1. 我们是谁</h2>
      <p>
        omw 由<strong>独立个人开发者</strong>开发并运营。「我们」指该开发者，是下文所述个人信息的<strong>数据控制者</strong>。官网：<a href="https://onmyway.city">onmyway.city</a>。
      </p>
      <p>
        隐私联系：<a href="mailto:privacy@onmyway.city">privacy@onmyway.city</a>
        <br />
        用户支持：<a href="mailto:support@onmyway.city">support@onmyway.city</a>
        <br />
        安全/举报：<a href="mailto:safety@onmyway.city">safety@onmyway.city</a>
      </p>

      <h2>2. 简要说明</h2>
      <ul>
        <li>我们<strong>不出售</strong>你的个人信息，不做第三方广告，也不使用 IDFA 进行跨应用追踪。</li>
        <li>我们收集运行社交地图产品所必需的信息：账号标识、资料、你发布的内容、使用地图/户外功能时的位置、使用行为与诊断数据。</li>
        <li>精确位置、后台位置（导航/轨迹录制）、推送通知、与 Cheese 助手语音交互、Premium 等功能需系统授权或在应用内开启。</li>
        <li>你可在应用内<strong>删除账户</strong>（个人资料 → 设置 → 账户 → 删除账户），或发邮件至 <a href="mailto:privacy@onmyway.city">privacy@onmyway.city</a>。</li>
        <li>使用「通过 Apple 登录」时，你可隐藏真实邮箱；我们仅收到 Apple 选择共享的信息。</li>
      </ul>

      <h2>3. 适用范围</h2>
      <p>
        本政策适用于 omw 移动应用（iOS/Android）、我们的 API 及 onmyway.city 网站。通过 omw 访问的第三方服务（如地图底图数据提供方、商家自有网站）适用其各自隐私政策。
      </p>

      <h2>4. 我们收集的信息</h2>
      <p>下表对应 Apple App Privacy 分类。「与你关联」指与账号或设备标识绑定。我们<strong>不</strong>将数据用于跨其他公司 App/网站的广告追踪。</p>
      <table>
        <thead>
          <tr>
            <th>Apple 分类</th>
            <th>具体内容</th>
            <th>与你关联？</th>
            <th>用于追踪？</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>联系信息</td>
            <td>邮箱（注册、Google 登录、Apple 登录）。手机号仅在商家完成企业验证（短信验证码）时使用。</td>
            <td>是</td>
            <td>否</td>
          </tr>
          <tr>
            <td>标识符</td>
            <td>omw 用户 ID、Firebase UID、Apple/Google 身份标识、推送 Token。</td>
            <td>是</td>
            <td>否</td>
          </tr>
          <tr>
            <td>用户内容</td>
            <td>昵称、头像、简介、兴趣、帖子、评论、活动、宝藏与照片、路线/轨迹、剧本内容、聊天消息、商家信息与优惠券、SOS 广播、数字遗嘱等你主动存储的内容。</td>
            <td>是</td>
            <td>否</td>
          </tr>
          <tr>
            <td>位置</td>
            <td>
              <strong>粗略与精确位置</strong>（经你授权）：地图中心、附近活动/宝藏、天气、路线导航、轨迹录制、活动签到、多人游戏、Cheese 近距离提醒（商家券与附近 SOS）、城市榜单。导航或录制进行中且你授权时，可能使用后台位置。
            </td>
            <td>是</td>
            <td>否</td>
          </tr>
          <tr>
            <td>使用数据</td>
            <td>功能使用、页面浏览、活动参与、路线浏览等行为事件，用于个性化推荐与城市榜单（如号召力/参与度等聚合指标）。</td>
            <td>是</td>
            <td>否</td>
          </tr>
          <tr>
            <td>诊断</td>
            <td>崩溃、性能、错误日志、应用与系统版本、设备型号。</td>
            <td>是</td>
            <td>否</td>
          </tr>
          <tr>
            <td>敏感信息</td>
            <td>你自愿填写的年龄、性别、交友意向等（可随时清空或在设置中关闭展示）。</td>
            <td>是</td>
            <td>否</td>
          </tr>
          <tr>
            <td>购买项目</td>
            <td>Apple 内购收据 ID、订阅状态、TestFlight 促销 Premium。我们不接收银行卡信息。</td>
            <td>是</td>
            <td>否</td>
          </tr>
        </tbody>
      </table>
      <p>
        <strong>我们不收集：</strong>通讯录、完整相册（仅你主动选择的图片）、应用外浏览记录、医疗健康档案、政府证件号、持续录音。Cheese 与 SOS 语音在设备上转写为文字，我们<strong>不</strong>在服务器存储原始音频。
      </p>

      <h2>5. 我们如何使用信息</h2>
      <ul>
        <li><strong>提供服务：</strong>登录、地图、活动、聊天、路线、榜单、商家工具等。</li>
        <li><strong>个性化：</strong>Cheese 助手、城市简报、活动推荐（基于行为事件与城市上下文）。</li>
        <li><strong>安全：</strong>限流、反滥用、拉黑举报、内容审核、SOS 可见性。</li>
        <li><strong>改进产品：</strong>聚合、去标识化的使用与稳定性分析。</li>
        <li><strong>通知：</strong>好友、聊天、活动等推送（可在系统设置关闭）。</li>
        <li><strong>法律合规：</strong>依法配合、记账与执行<Link to="/terms">服务条款</Link>。</li>
      </ul>

      <h2>6. AI、语音与助手功能</h2>
      <ul>
        <li><strong>Cheese 助手</strong>（个人/社区/城市情报）— 你发送的文字或语音转写内容可能传送至我们的服务器及 Google Gemini 等模型生成回复；我们尽量只发送必要上下文，不默认附带邮箱或精确坐标。</li>
        <li><strong>设备端语音</strong> — 通过 Apple 语音识别在本地转写，我们收到的是<strong>文本</strong>而非录音文件。</li>
        <li><strong>生成内容</strong> — 谜题、剧本、城市摘要等由 AI 生成，是否发布由你决定。</li>
      </ul>

      <h2>7. 位置信息（重要）</h2>
      <p>与 Geocaching、AllTrails 等户外/地图类应用类似，omw 依赖位置信息。原则如下：</p>
      <ul>
        <li><strong>先授权：</strong>系统会询问精确位置权限；拒绝后部分非地图功能仍可使用。</li>
        <li><strong>目的限定：</strong>仅为当前功能使用位置（地图、导航、活动、游戏、近距离提醒等）。</li>
        <li><strong>默认前台：</strong>多数功能仅在应用打开且活跃时使用位置。</li>
        <li><strong>后台位置：</strong>仅在路线导航或 GPS 轨迹录制等会话中、且你授权时可能持续更新；结束会话后停止。</li>
        <li><strong>Cheese 近距离（Premium）：</strong>应用在前台时可能周期性检查位置（常使用缓存/上次位置）以提示附近商家券或 SOS；关闭 Premium 或位置权限可停止。</li>
        <li><strong>不向数据经纪人出售精确位置。</strong></li>
      </ul>

      <h2>8. 榜单与号召力</h2>
      <p>
        城市榜单根据你组织活动、报名、签到、收藏等<strong>聚合行为</strong>计算（通常滚动 90 天）。上榜时可能展示你的昵称与头像。删除账户后不再参与后续排名。
      </p>

      <h2>9. 其他用户可见的信息</h2>
      <ul>
        <li>你设为公开的资料字段、发布的内容、参与 live 活动/游戏时的实时位置（仅会话期间）、聊天对象可见的消息、城市榜单中的排名。</li>
        <li>邮箱、手机号、登录标识<strong>不会</strong>对其他用户展示。</li>
      </ul>

      <h2>10. 委托处理的服务商</h2>
      <p>Google Cloud / Firebase、Google Gemini、Mapbox、Stream 聊天、Apple（登录/推送/语音）、Google 登录、OpenWeather、Twilio/邮件 SMTP（商家验证）等，均仅按我们的指示处理数据。详见英文版完整服务商表格。</p>

      <h2>11. 跨境传输</h2>
      <p>主要基础设施位于美国。在适用法律要求下，我们通过标准合同条款等方式保障跨境传输。</p>

      <h2>12. 保存期限</h2>
      <ul>
        <li>账户存续期间保存账户数据；删除账户后 30 天内匿名化或删除个人信息（法律要求保留的除外）。</li>
        <li>行为事件通常最多 24 个月；诊断日志约 30 天；备份约 35 天。</li>
      </ul>

      <h2>13. 你的权利</h2>
      <p>根据所在地区，你可能享有查阅、更正、删除、导出、限制处理、撤回同意等权利。应用内：个人资料 → 设置；或邮件 <a href="mailto:privacy@onmyway.city">privacy@onmyway.city</a>（30 日内回复）。</p>

      <h2>14. 账户删除</h2>
      <p>
        路径：<strong>个人资料 → 设置 → 账户 → 删除账户</strong>。须输入 <code>DELETE</code> 确认；用户名密码账户还需输入密码。删除后资料匿名化、OAuth/联系方式释放以便重新注册、推送停用并退出登录。
      </p>

      <h2>15. 未成年人</h2>
      <p>omw 不面向 13 周岁以下儿童（欧盟部分地区 16 周岁、中国 14 周岁）。如发现儿童注册请联系我们删除。</p>

      <h2>16. 追踪与 ATT</h2>
      <p>我们不做跨应用广告追踪，不使用 IDFA，不为广告目的展示 App Tracking Transparency 弹窗。</p>

      <h2>17. 安全与变更</h2>
      <p>我们采用 HTTPS、密码哈希、加密存储等措施。重大政策变更将在应用与本页更新。完整英文版含加州、澳大利亚等地区条款，以英文版为准；如有冲突，对你更有利的条款优先。</p>

      <h2>18. 联系我们</h2>
      <p>
        隐私：<a href="mailto:privacy@onmyway.city">privacy@onmyway.city</a>
        <br />
        支持：<a href="mailto:support@onmyway.city">support@onmyway.city</a>
        <br />
        安全：<a href="mailto:safety@onmyway.city">safety@onmyway.city</a>
      </p>
    </>
  );
}
